import { GET_ITEMS_TO_CONFIG,CHANGE_SETTING_LOCAL, SET_SHOW_SECTION, CHANGE_SETTING, CLEAN_STATE } from "./types";

const PreferencesReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ITEMS_TO_CONFIG:
            return {
                ...state,
                itemsToConfig: payload.itemsToConfig,
                isFetching: false,
                error: payload.error
            }
        case CHANGE_SETTING:
            return {
                ...state,
                isFetching: false,
                error: payload.error
            }
        case CLEAN_STATE:
            return {
                ...state,
                itemsToConfig: [],
                isFetching: true,
                error: {
                    ok: false,
                    text: ''
                },
            }
        case SET_SHOW_SECTION:
            return {
                ...state,
                showSection: payload,
            }
        case CHANGE_SETTING_LOCAL:
            return {
                ...state,
                itemsToConfig: payload,
            }
        default:
            return state;
    }
}

export default PreferencesReducer;